<template>
  <footer class="footer" role="contentinfo">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <RouterLink to="/" aria-label="الرئيسية — عقارات الكويت">
            <AppLogo size="sm" />
          </RouterLink>
          <p class="muted">
            شريكك الموثوق في شراء وبيع وتأجير العقارات في الكويت منذ أكثر من 15
            عاماً.
          </p>
        </div>
        <nav class="footer-col" aria-label="روابط سريعة">
          <h3>روابط سريعة</h3>
          <RouterLink to="/">الرئيسية</RouterLink>
          <RouterLink to="/properties">العقارات</RouterLink>
          <RouterLink to="/areas">المناطق</RouterLink>
          <RouterLink to="/services">خدماتنا</RouterLink>
        </nav>
        <nav class="footer-col" aria-label="مساعدة">
          <h3>مساعدة</h3>
          <RouterLink to="/about">من نحن</RouterLink>
          <RouterLink to="/faq">الأسئلة الشائعة</RouterLink>
          <RouterLink to="/blog">المدونة</RouterLink>
          <RouterLink to="/contact">تواصل معنا</RouterLink>
        </nav>
        <div class="footer-col">
          <h3>تواصل</h3>
          <a href="tel:+96522221234">+965 2222 1234</a>
          <a href="mailto:info@kuwait-realestate.kw"
            >info@kuwait-realestate.kw</a
          >
          <span class="muted">السالمية، الكويت</span>
        </div>
      </div>
      <p class="footer-copy muted">
        © {{ year }} عقارات الكويت. جميع الحقوق محفوظة.
      </p>
      <p class="footer-credit muted">DEVELOP BY ROOTK</p>
    </div>
  </footer>
</template>

<script setup>
import { RouterLink } from "vue-router";
import AppLogo from "@/components/mkdf/AppLogo.vue";

const year = new Date().getFullYear();
</script>

<style scoped>
.footer {
  background: var(--surface-card);
  border-top: 1px solid var(--border);
  padding-block: 48px 24px;
  margin-top: auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 32px;
}

@media (min-width: 640px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1.5fr 1fr 1fr 1fr;
  }
}

.footer-brand a {
  text-decoration: none;
  display: inline-block;
  margin-bottom: 12px;
}

.footer-brand p {
  margin: 0;
  font-size: 0.875rem;
  max-width: 280px;
  line-height: 1.5;
}

.footer-col h3 {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--content-heading);
  margin: 0 0 12px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-col a,
.footer-col span {
  font-size: 0.875rem;
  color: var(--content-muted);
  text-decoration: none;
}

.footer-col a:hover {
  color: var(--brand);
}

.footer-copy {
  text-align: center;
  font-size: 0.8125rem;
  margin: 0;
  padding-top: 24px;
  border-top: 1px solid var(--border);
}

.footer-credit {
  text-align: center;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 8px 0 0;
}
</style>
